import { configureStore } from "@reduxjs/toolkit"
import authSlice from "./slices/authSlice"
import studentSlice from "./slices/studentSlice"
import feeSlice from "./slices/feeSlice"
import facultySlice from "./slices/facultySlice"
import resultSlice from "./slices/resultSlice"
import documentSlice from "./slices/documentSlice"
import departmentSlice from "./slices/departmentSlice"

export const store = configureStore({
  reducer: {
    auth: authSlice,
    faculty: facultySlice,
    students: studentSlice,
    fees: feeSlice,
    results: resultSlice,
    documents: documentSlice,
    departments: departmentSlice,
  },
})
